import styled from 'styled-components'

interface IButtonProps {
  color?: string
  textColor?: string
  hoverColor?: string
  hoverTextColor?: string
}

export const ButtonSmall = styled.div<IButtonProps>`
	background: ${props => props.color ? props.color : '#000000'};
	color: ${props => props.textColor ? props.textColor : 'white'};
	border-radius: 25px;
	font-size: 14px;
	text-transform: uppercase;
	padding: 8px 18px;
	font-weight: 500;
	transition: .3s;
	&:hover{
		cursor: pointer;
		color: ${props => props.hoverTextColor ? props.hoverTextColor : 'white'};
		background: ${props => props.hoverColor ? props.hoverColor : '#000000'};
	}
`

export const ButtonStyleReg = styled.div`
	background: ${props => props.theme.buttonPrimary.color};
	color: ${props => props.theme.buttonPrimary.textColor};
	display: flex;
	justify-content: center;
	text-align: center;
	align-items: center;
	padding: 8px 20px;
	text-transform: uppercase;
	font-size: .8rem;
	font-weight: 600;
	border-radius: 50px;
`